import { db } from "../lib/firebase";

export default function Test() {
  console.log(db);

  return <div>Firebase Connected 🚀</div>;
}
